import React from 'react';
import { Link } from 'react-router-dom';

const PaymentGuide: React.FC = () => {
  return (
    <div className="min-h-screen bg-cream-100">
      <div className="section-container py-12 sm:py-16">
        {/* Header */}
        <div className="mb-8">
          <Link to="/" className="inline-flex items-center text-gold-400 hover:text-forest-800 mb-4">
            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
            Return to Home
          </Link>
          <h1 className="font-display text-display-sm text-forest-900">Payment Methods</h1>
          <p className="mt-2 text-warm-600">Choose a secure and convenient payment method</p>
        </div>

        <div className="space-y-8">
          {/* Email Payment */}
          <div className="bg-forest-50 border border-forest-200 rounded-xl p-6">
            <div className="flex items-center mb-4">
              <div className="w-10 h-10 bg-forest-700 rounded-full flex items-center justify-center mr-4">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
              <h2 className="text-xl font-semibold text-forest-900">Email Payment</h2>
            </div>
            <div className="space-y-3 text-forest-800">
              <p className="font-medium">After your order is placed, we will send you payment instructions via email.</p>
              <ul className="list-disc list-inside space-y-2 text-sm">
                <li>Payment instructions sent immediately after order confirmation</li>
                <li>Multiple payment methods available including crypto and wire transfer</li>
                <li>Product ships once payment is confirmed</li>
                <li>Reply to the email for any payment-related inquiries</li>
              </ul>
            </div>
          </div>

          {/* Payment Methods — crypto-only at launch */}
          <div className="bg-cream-50 rounded-xl border border-warm-200 shadow-card p-6">
            <h2 className="text-xl font-semibold text-forest-900 mb-6">Accepted Payment Method</h2>
            <div className="border border-warm-200 rounded-xl p-4">
              <div className="flex items-center mb-3">
                <svg className="w-6 h-6 mr-3 text-forest-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                <h3 className="font-semibold text-forest-900">Cryptocurrency</h3>
              </div>
              <ul className="text-sm text-warm-600 space-y-1">
                <li>Bitcoin (BTC), USDT (TRC-20), Litecoin (LTC), Monero (XMR)</li>
                <li>Fast and secure transactions</li>
                <li>Enhanced privacy protection</li>
                <li>Low transaction fees</li>
              </ul>
              <p className="mt-3 text-xs text-warm-500">
                Card, wire transfer, and digital wallets are not supported at this time.
              </p>
            </div>
          </div>

          {/* Security & Notes */}
          <div className="bg-cream-100 border border-warm-200 rounded-xl p-6">
            <h2 className="text-xl font-semibold text-forest-900 mb-4">Security & Important Notes</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <h3 className="font-semibold text-forest-900 mb-3">For Secure Payments</h3>
                <ul className="text-sm text-warm-600 space-y-2">
                  <li>Only trust payment instructions from our official email</li>
                  <li>Verify your order details and amount before paying</li>
                  <li>Report any suspicious links or requests immediately</li>
                  <li>Share personal information only through official channels</li>
                </ul>
              </div>
              <div>
                <h3 className="font-semibold text-forest-900 mb-3">Important Notes</h3>
                <ul className="text-sm text-warm-600 space-y-2">
                  <li>Never make additional payments requested by third parties</li>
                  <li>Use security software to protect your personal information</li>
                  <li>Always confirm payment completion after transacting</li>
                  <li>Contact us immediately in case of any issues</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Contact */}
          <div className="bg-cream-50 rounded-xl border border-warm-200 shadow-card p-6 text-center">
            <h2 className="text-xl font-semibold text-forest-900 mb-4">Payment Support</h2>
            <p className="text-warm-600 mb-6">
              If you have any questions or issues during the payment process, please don't hesitate to contact us.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <span className="inline-flex items-center px-6 py-3 bg-cream-100 border border-warm-200 text-forest-900 font-mono text-sm rounded-lg shadow-card select-all">
                support@liberacure.com
              </span>
              <Link
                to="/shop"
                className="inline-flex items-center px-6 py-3 border border-warm-200 text-forest-700 font-medium rounded-lg hover:bg-cream-100 transition-all duration-200"
              >
                Continue Shopping
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentGuide;
